module.exports = __webpack_public_path__ + "img/royalmail.7761deaf.png";